import { Link } from 'react-router-dom'
import { EnvelopeIcon } from '@heroicons/react/24/outline'

const Footer = () => {
  return (
    <footer className="bg-gradient-to-b from-slate-900 to-slate-950 text-white pt-16 sm:pt-20 pb-8 sm:pb-10 relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-500/30 to-transparent"></div>
      <div className="absolute top-20 right-0 w-[400px] h-[400px] bg-blue-500/5 rounded-full blur-[100px]"></div>
      <div className="absolute bottom-20 left-0 w-[300px] h-[300px] bg-purple-500/5 rounded-full blur-[80px]"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-8">
          {/* Brand & Subscription */}
          <div className="col-span-2 sm:col-span-2 lg:col-span-2">
            <div className="flex items-center space-x-2 mb-4 sm:mb-6">
              <span className="text-2xl sm:text-3xl">🎓</span>
              <h3 className="text-xl sm:text-2xl font-bold tracking-tight">云庠教育</h3>
            </div>
            <p className="text-gray-400 mb-6 sm:mb-8 max-w-sm leading-relaxed text-sm sm:text-base">
              连接全球顶尖教育资源，利用 AI 技术为您量身定制留学方案。
              开启您的名校之旅，从这里开始。
            </p>
            
            <div className="max-w-md">
              <h4 className="text-xs sm:text-sm font-semibold uppercase tracking-wider text-gray-500 mb-2 sm:mb-3">订阅我们的周刊</h4>
              <div className="flex flex-col xs:flex-row gap-2">
                <div className="relative flex-1">
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <EnvelopeIcon className="h-4 w-4 sm:h-5 sm:w-5 text-gray-500" />
                  </div>
                  <input 
                    type="email" 
                    placeholder="输入您的邮箱" 
                    className="block w-full pl-9 sm:pl-10 pr-3 py-2 sm:py-2.5 bg-gray-800 border border-gray-700 rounded-lg text-sm text-gray-300 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  />
                </div>
                <button className="px-5 sm:px-6 py-2.5 sm:py-3 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white text-sm font-semibold rounded-xl transition-all duration-300 shadow-lg shadow-blue-900/30 hover:shadow-blue-900/50 whitespace-nowrap">
                  订阅
                </button>
              </div>
              <p className="mt-2 text-[10px] sm:text-xs text-gray-500">
                我们承诺不会发送垃圾邮件。您可以随时取消订阅。
              </p>
            </div>
          </div>

          {/* Links Column 1 */}
          <div className="col-span-1">
            <h4 className="text-xs sm:text-sm font-bold uppercase tracking-wider text-gray-500 mb-4 sm:mb-6">探索平台</h4>
            <ul className="space-y-3 sm:space-y-4">
              <li>
                <Link to="/courses" className="text-gray-400 hover:text-white transition-colors flex items-center group text-sm sm:text-base">
                  <span className="hidden sm:block w-0 group-hover:w-2 h-0.5 bg-blue-500 mr-0 group-hover:mr-2 transition-all duration-300"></span>
                  浏览课程
                </Link>
              </li>
              <li>
                <Link to="/teachers" className="text-gray-400 hover:text-white transition-colors flex items-center group text-sm sm:text-base">
                  <span className="hidden sm:block w-0 group-hover:w-2 h-0.5 bg-blue-500 mr-0 group-hover:mr-2 transition-all duration-300"></span>
                  寻找导师
                </Link>
              </li>
              <li>
                <Link to="/ai" className="text-gray-400 hover:text-white transition-colors flex items-center group text-sm sm:text-base">
                  <span className="hidden sm:block w-0 group-hover:w-2 h-0.5 bg-blue-500 mr-0 group-hover:mr-2 transition-all duration-300"></span>
                  AI 助手
                  <span className="ml-1.5 sm:ml-2 px-1 sm:px-1.5 py-0.5 text-[8px] sm:text-[10px] font-bold bg-blue-600 text-white rounded uppercase">New</span>
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-400 hover:text-white transition-colors flex items-center group text-sm sm:text-base">
                  <span className="hidden sm:block w-0 group-hover:w-2 h-0.5 bg-blue-500 mr-0 group-hover:mr-2 transition-all duration-300"></span>
                  价格方案
                </Link>
              </li>
            </ul>
          </div>

          {/* Links Column 2 */}
          <div className="col-span-1">
            <h4 className="text-xs sm:text-sm font-bold uppercase tracking-wider text-gray-500 mb-4 sm:mb-6">支持与服务</h4>
            <ul className="space-y-3 sm:space-y-4">
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base">帮助中心</a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base">联系我们</a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base">隐私政策</a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base">服务条款</a>
              </li>
              <li>
                <Link to="/teacher-register" className="text-gray-400 hover:text-white transition-colors text-sm sm:text-base">
                  成为讲师
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 sm:mt-20 pt-8 sm:pt-10 border-t border-gray-800/50 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs sm:text-sm text-gray-500 text-center sm:text-left">
            © 2024 云庠教育 Philiapedia Education. All rights reserved.
          </p>
          
          <div className="flex space-x-5 sm:space-x-6">
            <SocialLink href="#" icon={<WechatIcon />} label="WeChat" />
            <SocialLink href="#" icon={<WeiboIcon />} label="Weibo" />
            <SocialLink href="#" icon={<TiktokIcon />} label="Douyin" />
            <SocialLink href="#" icon={<BilibiliIcon />} label="Bilibili" />
          </div>
        </div>
      </div>
    </footer>
  )
}

const SocialLink = ({ href, icon, label }: { href: string; icon: React.ReactNode; label: string }) => (
  <a 
    href={href} 
    className="text-gray-500 hover:text-white transition-colors transform hover:scale-110 duration-200"
    aria-label={label}
  >
    {icon}
  </a>
)

// 简单的SVG图标组件
const WechatIcon = () => (
  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
    <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.162 4.203 2.969 5.531L2.5 17.188l2.441-1.172c.684.129 1.379.195 2.25.195.429 0 .84-.027 1.25-.078-.117-.398-.187-.816-.187-1.266 0-3.27 2.718-5.92 6.078-5.92.675 0 1.316.097 1.922.266-.016-.266-.047-.531-.093-.797C15.81 3.891 12.691 2.188 8.691 2.188zm6.84 11.531c-2.969 0-5.25-2.062-5.25-4.594S12.562 4.531 15.531 4.531s5.25 2.062 5.25 4.594-2.281 4.594-5.25 4.594z"/>
  </svg>
)

const WeiboIcon = () => (
  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
  </svg>
)

const TiktokIcon = () => (
  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
)

const BilibiliIcon = () => (
  <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
    <path d="M18.8 6.75h-2.23l.93-2.06a.6.6 0 0 0-1.09-.5l-1.37 3.05h-6.36L7.31 4.19a.6.6 0 0 0-1.09.5l.93 2.06H4.92a2.1 2.1 0 0 0-2.1 2.1V16.8a2.1 2.1 0 0 0 2.1 2.1h13.88a2.1 2.1 0 0 0 2.1-2.1V8.85a2.1 2.1 0 0 0-2.1-2.1zM7.5 14.8a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm9 0a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5z"/>
  </svg>
)

export default Footer